<template>
  <section id="section__agreements">
    <StaticGuide align="left" :size="200" hide-channel>
      <template #logo><span></span></template>
      <template #contents>
        <v-row no-gutters class="pb-10">
          <v-col cols="12" class="mb-5">
            <SectionBenefit v-if="false" />
          </v-col>

          <v-col cols="12">
            <div class="agree-all-terms">
              <BasicCheckbox
                v-model="agreeAll"
                :checked.sync="agreeAll"
                :name="`service-agree-all`"
                @change="changeAgreeAll(agreeAll)"
              >
                <p class="font--m-4 ma-0">약관에 전체동의(선택사항 포함)</p>
              </BasicCheckbox>ㄴ
              <v-icon large @click="showTerms = !showTerms">
                {{ showTerms ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
              </v-icon>
            </div>
          </v-col>

          <HrSolid :classes="['my-2']" />

          <template v-if="isLoading">
            <v-progress-linear indeterminate />
          </template>

          <template v-else>
            <v-col cols="12" class="mb-3 px-1">
              <transition-group name="slide-y-transition">
                <template v-if="showTerms">
                  <div v-for="(term, index) in requiredTerms" :key="term.uuid" class="term-row">
                    <BasicCheckbox
                      v-model="term.isAgreed"
                      :checked.sync="term.isAgreed"
                      :name="`service-required_${index}`"
                    >
                      <p class="ma-0 font-size--15">
                        <span class="color--nice">(필수)</span>
                        <router-link class="color--black" :to="{ path: `/terms/${term.code}` }">
                          {{ term.title }}
                        </router-link>
                      </p>
                    </BasicCheckbox>
                  </div>

                  <div v-for="(term, index) in electiveTerms" :key="term.uuid" class="term-row">
                    <BasicCheckbox
                      v-model="term.isAgreed"
                      :checked.sync="term.isAgreed"
                      :name="`service-elective_${index}`"
                      @change="changeParent(term)"
                    >
                      <p class="ma-0 font-size--15">
                        <span>(선택)</span>
                        <router-link class="color--black" :to="{ path: `/terms/${term.code}` }">
                          {{ term.title }}
                        </router-link>
                      </p>
                    </BasicCheckbox>

                    <div style="display: flex">
                      <v-col cols="6" v-for="(child, index) in term.childs" :key="child.uuid">
                        <BasicCheckbox
                          :name="`service-optional_${index}`"
                          :checked.sync="child.isAgreed"
                          v-model="child.isAgreed"
                          @change="changeChild(child, term)"
                        >
                          <span>{{ child.title }}</span>
                        </BasicCheckbox>
                      </v-col>
                    </div>
                  </div>
                </template>
              </transition-group>
            </v-col>
          </template>
        </v-row>
      </template>

      <template #activator>
        <BasicButton
          v-if="false"
          @click="next(terms)"
          :loading="nextLoading"
          :disabled="nextLoading || checkRequired"
        >
          다음
        </BasicButton>
      </template>
    </StaticGuide>
  </section>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  components: {
    StaticGuide: () => import('@/components/common/guide/StaticGuide.vue'),
    SectionBenefit: () => import('@/components/landing/SectionBenefit.vue'),
  },
  data() {
    return {
      showTerms: false,
      terms: [],
      agreeAll: false,
      nextLoading: false,
    }
  },
  computed: {
    isLoading() {
      return this.terms.length < 1
    },
    requiredTerms() {
      return this.terms.filter((t) => t.isRequired === true)
    },
    electiveTerms() {
      return this.terms.filter((t) => t.isRequired === false)
    },
    checkRequired() {
      return this.terms.filter((t) => t.isRequired === true).find((t) => !t.isAgreed) ? true : false
    },
  },
  watch: {
    terms: {
      deep: true,
      handler(v) {
        let flag = true
        for (let i = 0; i < v.length; i++) {
          const term = v[i]
          if (term.isAgreed === false) {
            flag = false
            break
          }
          if (term.childs) {
            for (let j = 0; j < term.childs.length; j++) {
              const child = term.childs[j]
              if (child.isAgreed === false) {
                flag = false
                break
              }
            }
          }
        }
        this.agreeAll = flag
      },
    },
    checkRequired: {
      handler(v) {
        this.$emit('update:checkAll', v === false)
      },
    },
  },
  async created() {
    _meta({
      titles: ['서비스약관동의'],
    })
    this.terms = await this.getServiceTerms()
  },
  methods: {
    ...mapActions('account', ['getAccounts']),
    ...mapActions('agreement', ['getServiceTerms', 'postServiceTermsAgreements']),
    ...mapActions('auth', ['getMe', 'updateMe']),
    ...mapActions('store', ['updateStore']),
    async next() {
      try {
        this.nextLoading = true
        console.log(this.terms)
        await this.postServiceTermsAgreements(this.terms)
        await this.getAccounts()
      } finally {
        this.nextLoading = false
      }
    },
    changeAll(flag) {
      this.agreeAll = flag
    },
    changeParent(parent) {
      parent.childs.forEach((c) => {
        c.isAgreed = parent.isAgreed
      })
    },
    changeChild(child, parent) {
      if (parent.childs.find((c) => c.isAgreed === true)) {
        parent.isAgreed = true
      } else {
        parent.isAgreed = false
      }
    },
    changeAgreeAll(v) {
      this.terms.forEach((t) => {
        t.isAgreed = v
        if (t.childs) {
          t.childs.forEach((c) => {
            c.isAgreed = v
          })
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep(#section__benefit) {
  > div {
    margin: 0 !important;
  }
}

.agree-all-terms {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .checkmark {
    width: 24px;
    height: 24px;
  }

  .checkmark:after {
    left: 9px;
    top: 5px;
    width: 7px;
    height: 12px;
  }
}

.term-row {
  padding-top: 8px;
  padding-bottom: 8px;
}
</style>
